/**
 * Validation class for Distillate form
 * */
export default class DistillateFormValidation {
    /**
     * Init
     */
    constructor() {
        // Document Ready for jQuery validation
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.ready);
        } else {
            this.ready();
        }
    }

    /**
     * Callback - Init methods when page been loaded
     * @return void
     */
    ready = () => {
        this.validationForm();
        this.validationReciever();
    };

    /**
     * Jquery Validation for agreement
     * @return void
     */
    validationForm = (targetValue) => {
        $('#distillateForm').validate({
            rules: {
                customerName: {
                    required: true,
                    pattern: '^[0-9a-zA-ZÅÄÖåäöd.-]{2,25}(?: +[0-9a-zA-ZÅÄÖåäö]{2,25})+$',
                },
                customerAddress: {
                    required: true,
                    minlength: 4,
                },
                customerZipCodeAndCity: {
                    required: true,
                    pattern: '^[0-9a-zA-Zd.-]{2,20}(?: +[a-zA-ZÅÄÖåäö0-9]{2,40})+$',
                },
                customerOrganizationNumber: {
                    required: true,
                    pattern: '^[0-9d.-]{7}[0-9]{4}$',
                },
            },
            messages: {
                customerName: {
                    required: distillateTranslation.customerNameRequired,
                    pattern: distillateTranslation.customerNamePattern,
                },
                customerAddress: {
                    required: distillateTranslation.customerAddressRequired,
                    minlength: distillateTranslation.customerAddressMinLength,
                },
                customerZipCodeAndCity: {
                    required: distillateTranslation.customerZipCodeAndCityRequired,
                    pattern: distillateTranslation.customerZipCodeAndCityPattern,
                },
                customerOrganizationNumber: {
                    required: distillateTranslation.customerOrganizationNumberRequired,
                    pattern: distillateTranslation.customerOrganizationNumberPattern,
                },
            },
            submitHandler: function () {
                this.checkForm();
            },
        });
    };

    /**
     * Checking if fields are valid.
     * Adding/Removing disabled class if/or not
     * @param {*} steps
     * @return void
     */
    checkForm(steps) {
        switch (steps) {
            case 'form':
                if ($('#distillateForm').valid()) {
                    if (document.querySelectorAll('.distillateForm:checked').length > 0) {
                        document.getElementById('Step1Next').classList.remove('disabled');
                    }
                } else {
                    document.getElementById('Step1Next').classList.add('disabled');
                }
                break;
            case 'reciever':
                if ($('#distillateReciever').valid()) {
                    if (
                        document.querySelector('#ReceiverPersonalNumber').value.length > 0 &&
                        document.querySelector('#ReceiverEmail').value.length > 0
                    ) {
                        document.getElementById('Step2Next').classList.remove('disabled');
                    }
                } else {
                    document.getElementById('Step2Next').classList.add('disabled');
                }
                break;
            default:
                $('#distillateForm').valid();
        }
    }

    /**
     * Jquery  Validation for reciever form
     * @return void
     */
    validationReciever() {
        $('#distillateReciever').validate({
            rules: {
                ReceiverPersonalNumber: {
                    required: true,
                    pattern: '^[0-9]{12}$',
                },
                ReceiverEmail: {
                    required: true,
                    email: true,
                },
            },
            messages: {
                ReceiverPersonalNumber: {
                    required: distillateTranslation.personalNumberRequired,
                    pattern: distillateTranslation.personalNumberRegexPersonal,
                },
                ReceiverEmail: {
                    required: distillateTranslation.receiverEmailRequired,
                    email: distillateTranslation.receiverEmailFormat,
                },
            },
            submitHandler: function () {},
        });
    }
}
